import React from 'react';

export const PrintQualityIndicator = ({ status }) => {
  // Status can be 'good', 'fair', 'poor', or 'neutral'
  
  let backgroundColor, textColor, iconColor;
  
  switch (status.status) {
    case 'good':
      backgroundColor = 'bg-green-100';
      textColor = 'text-green-800';
      iconColor = 'bg-green-500';
      break;
    case 'fair':
      backgroundColor = 'bg-yellow-100';
      textColor = 'text-yellow-800';
      iconColor = 'bg-yellow-500';
      break;
    case 'poor':
      backgroundColor = 'bg-red-100';
      textColor = 'text-red-800';
      iconColor = 'bg-red-500';
      break;
    default:
      backgroundColor = 'bg-gray-100';
      textColor = 'text-gray-800';
      iconColor = 'bg-gray-500';
  }
  
  return (
    <div className={`p-2 rounded text-center ${backgroundColor}`}>
      <span className={`text-xs ${textColor}`}>{status.message}</span>
    </div>
  );
};